import * as S from './index.style'
import IconButton from '@material-ui/core/IconButton'
import Grid from 'components/Grid'
import { Close } from '@styled-icons/material-rounded/Close'

export type DialogHeaderProps = {
  /** Titulo exibido no componente */
  titulo: string
  closedDialog: () => void
}

/** Componente para exibição de titulo de dialog */
export const DialogHeader: React.FC<DialogHeaderProps> = ({ titulo, closedDialog }) => {
  return (
    <Grid orientacao="row" gridTemplateColumns="80% 20%" gridTemplateRow="1fr" gridGap="0" margin="0">
      <div>
        <S.Titulo>{titulo}</S.Titulo>
      </div>
      <S.DivRight>
        <IconButton color="primary" data-cy="btnFecharDialog" aria-label="close" onClick={closedDialog}>
          <Close size={24} />
        </IconButton>
      </S.DivRight>
    </Grid>
  )
}
export default DialogHeader
